// import Vue from "vue";
import httpService from "@/core/services/http.service.js";
var MockAdapter = require("axios-mock-adapter");

// Example array of services objects from api
const services = [
    {
        id: 1,
        name: "Children haircut",
        description: "Haircut for children",
        price: "250",
        is_price_public: true,
        duration: "30",
        is_duration_public: true,
        same_time_people: 1,
        break_duration: "0",
        service_category_id: 1,
        search_engine: {
            id: 1,
            name: "French",
        },
        place_id: 1,
    },
    {
        id: 2,
        name: "Men haircut",
        description: "Haircut for men",
        price: "250",
        is_price_public: true,
        duration: "30",
        is_duration_public: true,
        same_time_people: 1,
        break_duration: "0",
        service_category_id: 1,
        search_engine: {
            id: 1,
            name: "French",
        },
        place_id: 1,
    },
    {
        id: 3,
        name: "Coloring of long hair",
        description: "Hair coloring for long hair",
        price: "675",
        is_price_public: true,
        duration: "45",
        is_duration_public: true,
        same_time_people: 1,
        break_duration: "0",
        service_category_id: 2,
        search_engine: {
            id: 1,
            name: "French",
        },
        place_id: 1,
    },
    {
        id: 4,
        name: "Women haircut",
        description: "Haircut for women",
        price: "250",
        is_price_public: true,
        duration: "30",
        is_duration_public: true,
        same_time_people: 1,
        break_duration: "0",
        service_category_id: 3,
        search_engine: {
            id: 1,
            name: "French",
        },
        place_id: 2,
    },
    {
        id: 5,
        name: "Coloring of long hair",
        description: "Hair coloring for long hair",
        price: "675",
        is_price_public: true,
        duration: "45",
        is_duration_public: true,
        same_time_people: 1,
        break_duration: "0",
        service_category_id: 4,
        search_engine: {
            id: 1,
            name: "French",
        },
        place_id: 2,
    },
    {
        id: 6,
        name: "Coloring of short hair",
        description: "Hair coloring for short hair",
        price: "500",
        is_price_public: true,
        duration: "35",
        is_duration_public: true,
        same_time_people: 1,
        break_duration: "0",
        service_category_id: 4,
        search_engine: {
            id: 1,
            name: "French",
        },
        place_id: 2,
    },
];

// Example array of service categories from api
const serviceCategories = [
    {
        id: 1,
        name: "Category 1",
        place_id: 1,
        services: services.filter(
            (service) => service.service_category_id === 1
        ),
    },
    {
        id: 2,
        name: "Category 2",
        place_id: 1,
        services: services.filter(
            (service) => service.service_category_id === 2
        ),
    },
    {
        id: 3,
        name: "Category 3",
        place_id: 2,
        services: services.filter(
            (service) => service.service_category_id === 3
        ),
    },
    {
        id: 4,
        name: "Category 4",
        place_id: 2,
        services: services.filter(
            (service) => service.service_category_id === 4
        ),
    },
];

// Example array of staff objects from api
const staff = [
    {
        id: 1,
        first_name: "Employee",
        last_name: "1",
        email: "employee1@example.com",
        address: "Employee address 1",
        zip_code: "18000",
        city: "Nis",
        phone: "+381648102949",
        mobile: "+381648102949",
        avatar: "https://i.pravatar.cc",
        title: "Men hairdresser",
        places_ids: [1],
        services_ids: [2, 3],
    },
    {
        id: 2,
        first_name: "Employee",
        last_name: "2",
        email: "employee2@example.com",
        address: "Employee address 2",
        zip_code: "18000",
        city: "Nis",
        phone: "+381648102949",
        mobile: "+381648102949",
        avatar: "https://i.pravatar.cc",
        title: "Children hairdresser",
        places_ids: [1],
        services_ids: [1],
    },
    {
        id: 3,
        first_name: "Employee",
        last_name: "3",
        email: "employee3@example.com",
        address: "Employee address 3",
        zip_code: "18000",
        city: "Nis",
        phone: "+381648102949",
        mobile: "+381648102949",
        avatar: "https://i.pravatar.cc",
        title: "Women hairdresser",
        places_ids: [2],
        services_ids: [4, 5],
    },
    {
        id: 4,
        first_name: "Employee",
        last_name: "4",
        email: "employee4@example.com",
        address: "Employee address 4",
        zip_code: "18000",
        city: "Nis",
        phone: "+381648102949",
        mobile: "+381648102949",
        avatar: "https://i.pravatar.cc",
        title: "Women hairdresser",
        places_ids: [2],
        services_ids: [4],
    },
    {
        id: 5,
        first_name: "Employee",
        last_name: "5",
        email: "employee5@example.com",
        address: "Employee address 5",
        zip_code: "18000",
        city: "Nis",
        phone: "+381648102949",
        mobile: "+381648102949",
        avatar: "https://i.pravatar.cc",
        title: "Men hairdresser",
        places_ids: [2],
        services_ids: [6],
    },
];

// Example array of places objects from api
const places = [
    {
        id: 1,
        name: "Place 1",
        address: "Address place 1",
        latitude: "20.461",
        longitude: "40.23",
        phone: "+381649087625",
        email: "place1@example.com",
        logo: "data:image/png;base64,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",
        description: "Some description for place no. 1",
        opening_hours: {
            monday: { from: "06:00", to: "23:55" },
            tuesday: { from: "06:00", to: "23:55" },
            wednesday: { from: "06:00", to: "23:55" },
            thursday: { from: "06:00", to: "23:55" },
            friday: { from: "06:00", to: "23:55" },
            saturday: { from: null, to: null },
            sunday: { from: null, to: null },
        },
        rating: 4.8,
        staff: staff.filter((staffMember) =>
            staffMember.places_ids.includes(1)
        ),
        services: serviceCategories.filter(
            (category) => category.place_id === 1
        ),
    },
    {
        id: 2,
        name: "Place 2",
        address: "Address place 2",
        latitude: "21.54",
        longitude: "41.5",
        phone: "+381643896574",
        email: "place2@example.com",
        logo: "data:image/png;base64,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",
        description: "Some description for place no. 2",
        opening_hours: {
            monday: { from: "09:00", to: "18:00" },
            tuesday: { from: "09:00", to: "18:00" },
            wednesday: { from: "09:00", to: "18:00" },
            thursday: { from: "09:00", to: "18:00" },
            friday: { from: "09:00", to: "18:00" },
            saturday: { from: "09:00", to: "14:00" },
            sunday: { from: null, to: null },
        },
        rating: 4.8,
        staff: staff.filter((staffMember) =>
            staffMember.places_ids.includes(2)
        ),
        services: serviceCategories.filter(
            (category) => category.place_id === 2
        ),
    },
];

// Example array of clients objects from api
const clients = [
    {
        id: 1,
        first_name: "Dusan",
        last_name: "Ilic",
        email: "dusan@example.com",
        phone: "+381638796579",
        notes: "Allergic to nitrilie-gloves",
        notifications_enabled: true,
        address: "Sv. Markovica 6",
        city: "Nis",
        zip_code: "18000",
        appointments: [
            {
                date: "2020-11-05",
                start_time: "09:00",
                end_time: "09:30",
                status: "Completed",
                service_name: "Men haircut",
                price: "250",
            },
            {
                date: "2020-11-05",
                start_time: "09:30",
                end_time: "10:05",
                status: "Completed",
                service_name: "Coloring of short hair",
                price: "500",
            },
            {
                date: "2020-11-20",
                start_time: "12:00",
                end_time: "12:30",
                status: "Canceled",
                service_name: "Men haircut",
                price: "250",
            },
            {
                date: "2020-11-30",
                start_time: "16:30",
                end_time: "17:00",
                status: "Upcoming",
                service_name: "Men haircut",
                price: "250",
            },
        ],
    },
    {
        id: 2,
        first_name: "Josif",
        last_name: "Kostic",
        email: "joske@example.com",
        phone: "+381631239872",
        notes: "Allergic to nitrilie-gloves",
        notifications_enabled: false,
        address: "",
        city: "",
        zip_code: "",
        avatar: "https://i.pravatar.cc",
        appointments: [],
    },
    {
        id: 3,
        first_name: "Nikola",
        last_name: "Popovic",
        email: "popa@example.com",
        phone: "+38163786152",
        notes: "Allergic to nitrilie-gloves",
        notifications_enabled: false,
        address: "",
        city: "",
        zip_code: "",
        appointments: [],
    },
    {
        id: 4,
        first_name: "Vladimir",
        last_name: "Arsenijevic",
        email: "arsa@example.com",
        phone: "+381636791234",
        notes: "Allergic to nitrilie-gloves",
        notifications_enabled: true,
        address: "Anete Andrejevic 9",
        city: "Nis",
        zip_code: "18000",
        avatar: "https://i.pravatar.cc",
        appointments: [],
    },
];

const statistic = {
    1: {
        total_sales: 25800,
        total_appointments: 4,
        completed_appointments: 3,
        canceled_appointments: 1,
        top_services: [
            {
                service_name: "Men haircut",
                total_sales: "15000",
            },
            {
                service_name: "Children haircut",
                total_sales: "8400",
            },
            {
                service_name: "Coloring of long hair",
                total_sales: "2400",
            },
        ],
        staff_sales: [
            {
                first_name: "Employee",
                last_name: "1",
                precentage: 65,
            },
            {
                first_name: "Employee",
                last_name: "2",
                precentage: 35,
            },
        ],
    },
    2: {
        total_sales: 20013,
        total_appointments: 3,
        completed_appointments: 3,
        canceled_appointments: 0,
        top_services: [
            {
                service_name: "Women haircut",
                total_sales: "9000",
            },
            {
                service_name: "Coloring of long hair",
                total_sales: "6013",
            },
            {
                service_name: "Coloring of short hair",
                total_sales: "5000",
            },
        ],
        staff_sales: [
            {
                first_name: "Employee",
                last_name: "3",
                precentage: 40,
            },
            {
                first_name: "Employee",
                last_name: "4",
                precentage: 35,
            },
            {
                first_name: "Employee",
                last_name: "5",
                precentage: 25,
            },
        ],
    },
    total: {
        total_sales: 45813,
        total_appointments: 7,
        completed_appointments: 6,
        canceled_appointments: 1,
        top_services: [
            {
                service_name: "Men haircut",
                total_sales: "15000",
            },
            {
                service_name: "Women haircut",
                total_sales: "9000",
            },
            {
                service_name: "Children haircut",
                total_sales: "8400",
            },
            {
                service_name: "Coloring of long hair",
                total_sales: "6013",
            },
            {
                service_name: "Coloring of short hair",
                total_sales: "5000",
            },
        ],
        staff_sales: [
            {
                first_name: "Employee",
                last_name: "1",
                precentage: 30,
            },
            {
                first_name: "Employee",
                last_name: "2",
                precentage: 21,
            },
            {
                first_name: "Employee",
                last_name: "3",
                precentage: 18,
            },
            {
                first_name: "Employee",
                last_name: "4",
                precentage: 19,
            },
            {
                first_name: "Employee",
                last_name: "5",
                precentage: 12,
            },
        ],
    },
};

// Example

const MockService = {
    init() {
        // this sets the mock adapter on the default instance
        var mock = new MockAdapter(httpService);

        // mock to get places
        mock.onGet("/places").reply(() => {
            return [200, places];
        });

        // mock to get specific place
        mock.onGet(/\/place\/\d+/).reply(function (config) {
            let lastSlashIndex = config.url.lastIndexOf("/");
            let placeId = parseInt(config.url.slice(lastSlashIndex + 1));
            let place = places.find((place) => place.id === placeId);
            if (place) {
                return [200, place];
            }
            return [404, { message: "Not found" }];
        });

        // mock to get staff
        mock.onGet("/staff").reply(() => {
            return [200, staff];
        });

        // mock to get clients
        mock.onGet("/clients").reply(() => {
            return [200, clients];
        });

        // mock to get service categories
        mock.onGet("/service-categories").reply(() => {
            return [200, serviceCategories];
        });

        // mock to get services
        mock.onGet("/services").reply(() => {
            return [200, services];
        });

        // mock to get statistic
        mock.onGet(/statistic\/?.*/).reply(() => {
            // if (config.params.place_id) {
            //   return [200, statistic[config.params.place_id]];
            // }
            return [200, statistic.total];
        });

        mock.onAny().passThrough();
    },
};

export default MockService;

/**
 * Parse query strin parameters
 * @param {String} url
 * @return {Object}
 */
// function parseQueryString(url) {
//   const queryString = url.replace(/.*\?/, "");

//   if (queryString === url || !queryString) {
//     return null;
//   }

//   const urlParams = new URLSearchParams(queryString);
//   const result = {};

//   urlParams.forEach((val, key) => {
//     if (result.hasOwnProperty(key)) {
//       result[key] = [result[key], val];
//     } else {
//       result[key] = val;
//     }
//   });

//   return result;
// }
